import { constants } from "redux/constants/redux-constants";

export const setTokenExpired = payload => ({
	type: constants.SET_TOKEN_EXPIRED,
	payload,
})
